function formatDate() {
  const d = new Date();
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return `${yyyy}${mm}${dd}`;
}

function escapeCsvField(value) {
  const str = String(value);
  if (str.includes(',') || str.includes('"') || str.includes('\n') || str.includes('\r')) {
    return `"${str.replace(/"/g, '""')}"`;
  }
  return str;
}

export async function exportToExcel(rows, columns, sheetName, filename) {
  const headers = columns.map((c) => c.label);
  const data = rows.map((row) =>
    columns.map((c) => {
      const val = row[c.key];
      if (c.type === 'checkbox') return val ? 'はい' : 'いいえ';
      return val ?? '';
    }),
  );

  const csvRows = [headers, ...data].map((row) =>
    row.map(escapeCsvField).join(','),
  );
  const bom = '\uFEFF';
  const csvString = bom + csvRows.join('\r\n');
  const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename || `${sheetName}_${formatDate()}.csv`;
  a.click();
  URL.revokeObjectURL(url);
}
